if (!navigator.mediaDevices) {
  navigator.mediaDevices = {};
}

if (!(navigator.mediaDevices.getUserMedia instanceof Function)) {
  // compatibility layer needed.
  navigator.mediaDevices.getUserMedia = constraints =>
    new Promise((resolve, reject) => {
      if (!navigator.webkitGetUserMedia && !navigator.getUserMedia) {
        return reject(new Error('User Media not available on this device.'));
      }
      return navigator.webkitGetUserMedia(
        constraints,
        stream => resolve(stream),
        err => reject(err),
      );
    });
}

/**
 * stub getSupportedConstraints if it doesnt exist
 */
if (!(navigator.mediaDevices.getSupportedConstraints instanceof Function)) {
  navigator.mediaDevices.getSupportedConstraints = () => ({});
}



// WEBPACK FOOTER //
// ./src/lib/GetUserMedia.js